import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_034",
  "use": "icon-su_034-usage",
  "viewBox": "0 0 40 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 24\" id=\"icon-su_034\"><defs><style>#icon-su_034 .cls-1{fill:#aaa;}</style></defs><g id=\"icon-su_034_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_034_icon\"><rect class=\"cls-1\" width=\"40\" height=\"24\" rx=\"12\" /><circle class=\"cls-2\" cx=\"28\" cy=\"12\" r=\"9\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol